// Backup download link classification (QA scenario 1.6.9)
//
// GET /backups/:id/download returns a pre-signed S3 URL when AWS credentials
// are configured. Without them the API falls back to a `file://` path on the
// API server's own disk (upload.service.ts generateDownloadUrl). A page served
// over http(s) cannot open a file:// URL — window.open is blocked silently —
// so the page must explain where the backup is instead of handing out a dead
// link.

export interface BlockedDownloadNotice {
  title: string;
  description: string;
}

/**
 * Returns a notice to show instead of opening the link when the URL cannot be
 * fetched by a browser, or null when it is an ordinary http(s) link.
 */
export function blockedDownloadNotice(downloadUrl: string): BlockedDownloadNotice | null {
  if (/^https?:\/\//i.test(downloadUrl)) return null;
  const serverPath = downloadUrl.replace(/^file:\/\//i, '');
  return {
    title: 'Backup is stored on the server, not in S3',
    description: `S3 is not configured, so this backup can only be copied from the API server's disk at ${serverPath}. Configure AWS S3 credentials to download backups from the browser.`,
  };
}
